export const offboardingReasons = [
  {
    id: 'lackOfAssets',
    label: 'Lack of assets / resources',
  },
  {
    id: 'doesNotFitNeeds',
    label: `Doesn't fit my needs`,
  },
  {
    id: 'pause',
    label: 'Just taking a break (Pause)',
  },
  {
    id: 'tooExpensive',
    label: 'Too expensive',
  },
  {
    id: 'noLongerNeeded',
    label: 'No longer needed',
  },
  {
    id: 'other',
    label: 'Other',
    hasExtraInput: true,
  },
] as const;

export const freeTrialOffboardingReasons = [
  {
    id: 'tryingOut',
    label: 'I was just trying it out',
  },
  ...offboardingReasons,
] as const;

export type OffboardingReasons =
  | typeof offboardingReasons
  | typeof freeTrialOffboardingReasons;
export type OffboardingReasonId = OffboardingReasons[number]['id'];
